import { Platform } from 'react-native';
import * as Haptics from 'expo-haptics';

const isNative = Platform.OS !== 'web';

export const haptics = {
  light:     () => isNative && Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light),
  medium:    () => isNative && Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium),
  heavy:     () => isNative && Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy),
  success:   () => isNative && Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success),
  error:     () => isNative && Haptics.notificationAsync(Haptics.NotificationFeedbackType.Error),
  warning:   () => isNative && Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning),
  selection: () => isNative && Haptics.selectionAsync(),
};
